import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxPaginationModule } from 'ngx-pagination';
import { provideAuth } from 'angular-auth-oidc-client';
import { environment } from '../environments/environment';
import { sidexApiAuthInterceptor } from './shared/services/sidex-api-auth.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            FormsModule,
            FileUploadModule,
            NgxPaginationModule,
            MatDialogModule,
            MatCheckboxModule,
            MatRadioModule
        ),
        provideAuth({
            config: environment.auth
        }),
        provideHttpClient(withInterceptors([sidexApiAuthInterceptor])),
        provideAnimations(),
        provideZoneChangeDetection()
    ]
};
